module.exports = __webpack_public_path__ + "img/9.87367c3b.jpg";